import React, { useState, useEffect, useCallback } from 'react';
import { InputText, DropdownField } from 'components/common/input';
import BaseModalForm from 'components/common/modal/BaseModalForm';
import { Alert } from 'react-bootstrap';
import { useFormHandlers } from 'core/hooks/form/formHandlers';
import { MODAL_FORM_ERRORS } from 'core/constant/MODAL_FORM_ERRORS';
import { typeFilter } from 'core/constant/SELECT_OPTIONS';
import { iconOptions } from 'core/config/iconOptions';

const EditFilterModal = ({ show, filter, handleClose, handleSave, updating, errors, requestError }) => {
  const [formValues, setFormValues] = useState(filter);
  const [internalFeatures, setInternalFeatures] = useState([]);
  const [featuresToDelete, setFeaturesToDelete] = useState([]);
  const { handleChange } = useFormHandlers(setFormValues);

  useEffect(() => {
    setFormValues(filter);
    setInternalFeatures(filter?.options || []);
  }, [filter]);

  const handleFeatureChange = (index, key, value) => {
    const newFeatures = [...internalFeatures];
    newFeatures[index] = { ...newFeatures[index], [key]: value };
    setInternalFeatures(newFeatures);
  };

  const addFeature = () => {
    setInternalFeatures([...internalFeatures, { label: "", type: "" }]);
  };

  const removeFeature = (index) => {
    const feature = internalFeatures[index];
    if (feature.id) {
      setFeaturesToDelete([...featuresToDelete, feature.id]);
    }
    setInternalFeatures(internalFeatures.filter((_, i) => i !== index));
  };

  const handleSaveClick = useCallback(() => {
    handleSave({ ...formValues, id: filter?.id }, internalFeatures, featuresToDelete);
  }, [formValues, filter?.id, handleSave, internalFeatures, featuresToDelete]);

  return (
    <BaseModalForm show={show} title={filter?.id ? "Editar Detalle de Filtro" : "Crear Detalle de Filtro"} handleClose={handleClose} handleSave={handleSaveClick} updating={updating}>
      <div className="row">
        <div className="col-md-6 form-group">
          <InputText
            name="name"
            label="Name"
            value={formValues?.name}
            onChange={(e) => handleChange('name', e.target.value)}
            placeholder="Ingrese el nombre"
            error={errors?.name}
          />
        </div>
        <div className="col-md-6 form-group">
          <DropdownField
              label="Tipo de Filtro"
              name="type"
              value={formValues?.type}
              options={typeFilter}
              onChange={(e) => handleChange('type', e.value)}
              placeholder="Seleccione un tipo de filtro"
              error={errors?.type}
            />
        </div>
        <section className="m-0 p-0">
          <div className="row">
            {internalFeatures?.map((feature, index) => (
              <React.Fragment key={index}>
                <div className="col-md-6">
                  <InputText
                    name="value"
                    label="Valor"
                    value={feature.value}
                    onChange={(e) => handleFeatureChange(index, 'value', e.target.value)}
                    error={errors[index]?.value}
                  />
                </div>
                <div className="col-md-5">
                  <DropdownField
                    name="icon"
                    label="Icono"
              options={iconOptions}
              value={feature?.icon}
                    onChange={(e) => handleFeatureChange(index, 'icon', e.target.value)}
                    error={errors[index]?.icon}
                  />
                </div>
                <div className="col-md-1">
                  <div className="d-flex justify-content-end align-items-center h-100">
                    <i className={feature.icon} style={{ fontSize: '24px', marginRight: '10px' }} />
                    <button
                      type="button"
                      onClick={() => removeFeature(index)}
                      className="delete-table delete-button"
                    >
                      <i className="fa fa-trash" />
                    </button>
                  </div>
                </div>
              </React.Fragment>
            ))}
          </div>
          <button className="btn btn-primary-400 ms-3 mb-3" type="button" onClick={addFeature}>
            <i className="fa fa-plus-circle me-2" aria-hidden="true" />
            Añadir Valor
          </button>
        </section>
        <div className="col-12 form-group mt-3">
          {requestError &&
            <Alert variant="danger">
              {requestError?.response?.data?.message ||
               MODAL_FORM_ERRORS.FILTERS}
            </Alert>
          }
        </div>
      </div>
    </BaseModalForm>
  );
};

export default React.memo(EditFilterModal);
